import { css } from 'styled-components';

/**
 * WCAG 2.4.7 keyboard focus ring for mi-chat-components (Phoenix chat ADA default).
 * Use in styled-components; for markdown classes or third-party DOM use chat.scss instead.
 *
 * @see _docs/ada-patterns.md
 */
export const chatKeyboardFocusVisible = css`
  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: -webkit-focus-ring-color auto 1px;
  }
`;
